export default __webpack_public_path__ + "static/media/amazon-clone.de869ff3.png";